import {groupBy, kebabCase, keys, map} from 'lodash';

// student-profile
import StudentData from './student-data';
import {courseGroupingKey} from 'portfolio/components/bulk-entry/utils';

export default class CommunityCollegeStudentData extends StudentData {
  constructor({student, collegeDataForStudent, hideSensitiveDemographics}) {
    super({student, collegeDataForStudent, hideSensitiveDemographics});
    this.info = student.communityCollegeInfo;
  }

  matriculationText = () => `${this.info.transferSemester} ${this.matriculationYear()}`;

  matriculationYear = () => this.info.transferYear;

  isMilitary = () => this.info.militaryService === 'Yes';

  isLowIncome = () => (this.hideSensitiveDemographics ? null : this.info.lowIncome === 'Yes');

  hasCourses = () => !!this.portfolio.collegeCourses.length;

  courses = () => {
    const collegeCourses = map(this.portfolio.collegeCourses, (course) => ({
      ...course,
      grades: [course.grade],
      awardableCredits: course.creditHours,
      name: `${course.courseCode} | ${course.name}`,
    }));
    const coursesForTerm = groupBy(collegeCourses, (course) => `${course.semester} ${course.year}`);

    return map(keys(coursesForTerm), (term) => {
      const courses = coursesForTerm[term];

      return {
        term: kebabCase(term),
        termText: term,
        groupedCourses: groupBy(courses, (course) => JSON.stringify(courseGroupingKey(course))),
      };
    });
  };
}
